<template>
  <div>
    <template v-if="info !== null">
      <b-row>
        <b-col sm="12">
          <b-row>
            <b-col sm="12">
              <div class="float-left pr-4 pb-4" style="max-width:350px;">
                <div class="carousel-wrapper">
                  <img :src="info.images[0]" class="print-only" style="width:200px;" />
                  <b-card no-body class="noPrint">
                    <b-carousel
                      id="carousel"
                      controls
                      indicators
                      v-if="info.images.length">
                      <b-carousel-slide v-for="(image,imageIndex) in info.images" :key="imageIndex">
                        <template slot="img">
                          <img :src="image.url" class="card-img-top" />
                        </template>
                      </b-carousel-slide>
                    </b-carousel>
                    <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
                    <b-card-footer class="bg-light noPrint" v-if="info.files.length">
                      <!-- <h6 class="modal-title border-bottom mb-2">Fisiere atasate</h6> -->
                      <b-list-group v-for="(file, fileIndex) in info.files" :key="'file' + fileIndex" flush>
                        <b-list-group-item target="_self" :href="file.url" class="py-1 pl-1 bg-light">
                          <b-icon icon="file-earmark-text" scale="1.3" class="mr-1 text-danger"/>
                          <b>{{ file.label }}</b>
                        </b-list-group-item>
                      </b-list-group>
                    </b-card-footer>
                  </b-card>
                </div>
              </div>
              <h4 class="font-weight-bold d-inline border-bottom pb-2">{{ info.name }}
                <sup class="text-warning" v-if="starsIsNumber">
                  <span v-for="star in info.class" :key="star">
                    <img src="@/assets/images/icons/star.png" alt="" class="star" style="height: 14px; margin: 0px 1px;">
                  </span>
                </sup>
                <span v-else class="text-warning">{{ info.class }}</span>
              </h4>
              <h6 class="d-inline ml-2 text-info">{{info.extraClass}}</h6>

              <span class="" v-if="info.description || info.url || info.descriptions.length">
                <h5 class="modal-title mt-3 mb-2"><b v-translate>Description</b></h5>
                <p style="white-space: pre-line; text-align: justify;" v-if="result.isInhouse || result.isEtripHotels">{{ info.description }}</p>
                <p style="white-space: pre-line; text-align: justify;" v-if="!result.isInhouse && !result.isEtripHotels" v-html="info.description"></p>
                <span v-for="(desc, descIndex) in info.descriptions" :key="'desc' + descIndex">
                  <h6 class="modal-title">{{ desc.label }}</h6>
                  <p v-html="desc.text"></p>
                </span>
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="info.description || info.url || info.descriptions.length">
        <b-col>
          <small v-if="info.url">
            <a :href="info.url" target="_blank">{{ info.url }}</a>
          </small>
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col md="12" class="text-center pt-3">
        <b-aspect aspect="10">
          <b-spinner type="grow" label="Se incarca"></b-spinner>
          <p v-translate>Please wait...</p>
        </b-aspect>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
  .print-only {
    display: none!important;
  }
</style>

<script>
import { getHotelInfo } from 'b2b-common/services/api/hotel'

export default {
  name: 'HotelInfo',
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      info: null
    }
  },
  computed: {
    starsIsNumber () {
      return Number.isInteger(this.info.class)
    }
  },
  async created () {
    const info = await getHotelInfo({ hotelId: this.result.id })
    if (info.length) {
      this.info = {}
      for (const key in info[0]) {
        this.$set(this.info, key, info[0][key])
      }
    }
  }
}
</script>
